import { type SVGProps } from 'react';

import { withDynamicStroke } from '../../withDynamicStroke';
const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18 14.672V6m0 0H9.328M18 6 6 18"
    />
  </svg>
);
export const IconTrendUp = withDynamicStroke(Icon);
